import api from "../..";
import { uploadFile } from "../../file/uploadFile";
import type { ApiResponse } from "../../types";
import type {
  CreateContentBannerParams,
  CreateTopBannerParams,
} from "./types";
import {
  TOP_ENDPOINT,
  CONTENT_ENDPOINTS,
  CONTENT_FK_FIELD,
  UPLOAD_ITEM_TYPE,
} from "./types";

const upload = async (file: File): Promise<string> =>
  uploadFile({
    file,
    signBody: {
      item_type: UPLOAD_ITEM_TYPE,
      item_id: Date.now(),
      object_name: file.name,
      object_type: "image",
      object_size: file.size,
    },
  });

export const createTopBanner = async (
  params: CreateTopBannerParams,
): Promise<boolean> => {
  const {
    banner_type,
    title,
    url,
    description,
    is_active,
    expires_at,
    desktopImageFile,
    phoneImageFile,
  } = params;

  const desktop_image = await upload(desktopImageFile);
  const phone_image = phoneImageFile ? await upload(phoneImageFile) : null;

  return await api
    .post<ApiResponse<unknown>>(TOP_ENDPOINT, {
      banner_type,
      title,
      url,
      description,
      is_active,
      expires_at,
      desktop_image,
      phone_image,
    })
    .then(() => true)
    .catch(() => false);
};

export const createContentBanner = async (
  params: CreateContentBannerParams,
): Promise<boolean> => {
  const {
    contentType,
    title,
    url,
    description,
    is_active,
    content_id,
    desktopImageFile,
    phoneImageFile,
  } = params;

  const desktop_image = await upload(desktopImageFile);
  const phone_image = phoneImageFile ? await upload(phoneImageFile) : null;

  const body: Record<string, unknown> = {
    title,
    url,
    description,
    is_active,
    desktop_image,
    phone_image,
  };
  body[CONTENT_FK_FIELD[contentType]] = content_id;

  return await api
    .post<ApiResponse<unknown>>(CONTENT_ENDPOINTS[contentType], body)
    .then(() => true)
    .catch(() => false);
};
